import { CollectionHero, HubTiles } from "@/components/CollectionHero";

const CARPET_HUB = {
  crumbs: [
    { label: "Our Collection", to: "/collection" },
    { label: "Custom Carpet Collection" },
  ],
  eyebrow: "Our Collection / Custom Carpet",
  title: "Custom Carpet Collection",
  intro:
    "Bespoke soft flooring for residential and commercial interiors. Choose from our made-to-order custom carpet or explore our modular carpet tiles.",
  heroSlides: ["/assets/custom-carpet/hub-hero.jpg"],
  categories: [
    { label: "Custom Carpet", to: "/collections/custom-carpet-range", image: "/assets/custom-carpet/custom-carpet-hub.jpg", caption: "Made-to-order woven carpet" },
    { label: "Carpet Tiles", to: "/collections/carpet-tiles", image: "/assets/carpet-hero/carpet-tiles-hero.jpg", caption: "Modular carpet tiles" },
  ],
};

export default function CustomCarpetHub() {
  return (
    <div data-testid="custom-carpet-hub">
      <CollectionHero
        crumbs={CARPET_HUB.crumbs}
        eyebrow={CARPET_HUB.eyebrow}
        title={CARPET_HUB.title}
        intro={CARPET_HUB.intro}
        heroSlides={CARPET_HUB.heroSlides}
      />
      <HubTiles items={CARPET_HUB.categories} columns="md:grid-cols-2" />
    </div>
  );
}
